export default __webpack_public_path__ + "static/media/prod.903d6f4b.svg";